//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: [
        'nameValue'
    ],
    data () {
        return {
            form: {},
            isDisabled: true,
            isTrytimeZero: false,
            trytime: '',
        }
    },
    watch: {
  
    },
    methods: {
        init: function() {
            this.$get(this.getStore('fy') + '/setting/getvalue?key=sealpw_trytime', (data, res) => {
                if(data!=0) {
                    this.isDisabled = false;
                    this.isTrytimeZero = false;
                } else {
                    this.isTrytimeZero = true;
                    this.isDisabled = true;
                }
                this.trytime = data
            });
        },
        beforeSend: function() {
            if(this.form.fnewpwd!==this.form.snewpwd) {
                this.$message({type: 'error', message: '新密码与确认密码不一致！'});  
            }
        },
        afterSend: function() {
            this.init();
        },
        cancleHandler: function() {
            this.$emit("close")
        }
    },
    mounted: function() {
        this.init();
    }
}
